import { isSuccessfulStatusCode } from '../../../../helpers/api-ts/request'
import { isFetchCollectionResultSuccessful } from '../../../entities/FetchResult'
import { getLoketLeaveOfAbsencesHoursApiCall } from '../../../entities/LeaveOfAbsenceHour/LeaveOfAbsenceHourService'
import { LoketLeaveSyncFormData } from '../../../entities/LoketLeaveSync/LoketLeaveSync'
import { putLoketLeaveSyncApiCall } from '../../../entities/LoketLeaveSync/LoketLeaveSyncService'
import trans from '../../../helpers/trans'
import { ToastType } from '../../../types'
import { TypedDispatch } from '../../store'
import { setToast } from '../../toasts/toastsReducer'
import {
    setError,
    setIsLoading,
    setIsLoketLeaveSyncSuccessful,
    setIsSuccessful,
    setLeaveOfAbsenceHours,
    setLoketLeaveSyncErrors,
} from './exportLeaveOfAbsencesFormReducer'

export const syncLeaveOfAbsencesToLoket = (exportLeaveOfAbsencesFormData: LoketLeaveSyncFormData) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setLoketLeaveSyncErrors([]))
    dispatch(setLeaveOfAbsenceHours([]))
    dispatch(setIsSuccessful(false))
    dispatch(setIsLoketLeaveSyncSuccessful(false))

    try {
        const { status } = await putLoketLeaveSyncApiCall(exportLeaveOfAbsencesFormData)
        if (isSuccessfulStatusCode(status)) {
            dispatch(setIsLoketLeaveSyncSuccessful(true))
        } else {
            // noinspection ExceptionCaughtLocallyJS (because we want to handle all errors the same way)
            throw new Error('Loket leave sync failed')
        }
    } catch (error) {
        dispatch(setIsLoketLeaveSyncSuccessful(false))
        dispatch(setToast({
            text: trans('errors.loketUnknownError'),
            type: ToastType.warning,
            shouldFadeOutAutomatically: false,
        }))
    } finally {
        dispatch(setIsLoading(false))
    }
}

export const getLoketLeaveOfAbsenceHours = (leaveOfAbsenceHourIds: string[]) => async (dispatch: TypedDispatch): Promise<void> => {
    try {
        const loketLeaveOfAbsenceHours = await Promise.all(leaveOfAbsenceHourIds.map(async (leaveOfAbsenceHourId) => {
            const response = await getLoketLeaveOfAbsencesHoursApiCall(leaveOfAbsenceHourId)

            if (! isFetchCollectionResultSuccessful(response)) {
                console.error('[getLeaveOfAbsencesHoursApiCall]', response.error)

                throw Error(response.error)
            }

            return response.data
        }))

        dispatch(setLeaveOfAbsenceHours(loketLeaveOfAbsenceHours))
        dispatch(setIsSuccessful(true))
    } catch {
        dispatch(setError(trans('errors.unknownError')))
    }

    dispatch(setIsLoading(false))
}
